export const SHOW_SUCCESS_SNACKBAR = 'SHOW_SUCCESS_SNACKBAR';
export const SHOW_WARNING_SNACKBAR = 'SHOW_WARNING_SNACKBAR';
export const SHOW_DANGER_SNACKBAR = 'SHOW_DANGER_SNACKBAR';
export const SHOW_DEFAULT_SNACKBAR = 'SHOW_DEFAULT_SNACKBAR';

export const HIDE_SUCCESS_SNACKBAR = 'HIDE_SUCCESS_SNACKBAR';
export const HIDE_WARNING_SNACKBAR = 'HIDE_WARNING_SNACKBAR';
export const HIDE_DANGER_SNACKBAR = 'HIDE_DANGER_SNACKBAR';
export const HIDE_DEFAULT_SNACKBAR = 'HIDE_DEFAULT_SNACKBAR';

export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const LOGOUT = 'LOGOUT';

export const LOAD_QUESTIONS = 'LOAD_QUESTIONS';
export const SELECT_QUESTION = 'SELECT_QUESTION';
export const CLEAN_SELECTED_QUESTION = 'CLEAN_SELECTED_QUESTION';

export const LOAD_CATEGORIES = 'LOAD_CATEGORIES';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';
export const CLEAN_SELECTED_CATEGORY = 'CLEAN_SELECTED_CATEGORY';

export const LOAD_USERS = 'LOAD_USERS';
export const SELECT_USER = 'SELECT_USER';
export const CLEAN_SELECTED_USER = 'CLEAN_SELECTED_USER';

export const LOAD_JOBCOINS_PACKETS = 'LOAD_JOBCOINS_PACKETS';
export const SELECT_JOBCOINS_PACKET = 'SELECT_JOBCOINS_PACKET';
export const CLEAN_SELECTED_JOBCOINS_PACKET = 'CLEAN_SELECTED_JOBCOINS_PACKET';

export const LOAD_COMPANY = 'LOAD_COMPANY';
export const SELECT_COMPANY = 'SELECT_COMPANY';
export const CLEAN_SELECTED_COMPANY = 'CLEAN_SELECTED_COMPANY';

export const LOAD_DEMANDS = 'LOAD_DEMANDS';
export const SELECT_DEMAND = 'SELECT_DEMAND';
export const CLEAN_SELECTED_DEMAND = 'CLEAN_SELECTED_DEMAND';

export const LOAD_LOCALIZATIONS = 'LOAD_LOCALIZATIONS';

export const LOAD_GROUPS = 'LOAD_GROUPS';

export const LOAD_WHATSAPP_MESSAGES = 'LOAD_WHATSAPP_MESSAGES';

export const LOAD_REVIEWS = 'LOAD_REVIEWS';
export const SELECT_REVIEW = 'SELECT_REVIEW';
export const CLEAN_SELECTED_REVIEW = 'CLEAN_SELECTED_REVIEW';

//export const LOAD_ALL_DEMANDS = 'LOAD_ALL_DEMANDS';